<template>
  <div style="margin-top: 250px">

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("pusingan") }}
      </v-card-title>

      <!-- <v-simple-table width="auto" dense>
          <template v-slot:default>
          <thead>
              <tr>
              <th class="text-left">No</th>
              <th class="text-left">ID</th>
              <th class="text-left">Tahun</th>
              <th class="text-left">Bulan</th>
              <th class="text-left">Pusingan</th>
              <th>JOHOR</th>
              <th>KEDAH</th>
              <th>KELANTAN</th>
              <th>MELAKA</th>
              <th>N.SEMBILAN</th>
              <th>PAHANG</th>
              <th>P.PINANG</th>
              <th>PERAK</th>
              <th>PERLIS</th>
              <th>SELANGOR</th>
              <th>TERENGGANU</th>
              <th>SABAH</th>
              <th>SAWARAK</th>
              <th>W.P KUALA LUMPUR</th>
              <th>W.P PUTRAJAYA</th>
              <th>W.P LABUAN</th>
              <th>HQ</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item, index) in listPusingan" :key="index" @click="handleclick(item,index)">
                  <td>
                      {{index + 1}}
                  </td>
                  <td> {{ item.pusinganid }} </td>
                  <td> {{ item.tahun }} </td>
                  <td> {{ item.bulan }} </td>
                  <td> {{ item.pusingan }} </td>
                  <td v-if="item['01'] == 1 || item['01'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text"> <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['02'] == 1 || item['02'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['03'] == 1 || item['03'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['04'] == 1 || item['04'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['05'] == 1 || item['05'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['06'] == 1 || item['06'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['07'] == 1 || item['07'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['08'] == 1 || item['08'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['09'] == 1 || item['09'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['10'] == 1 || item['10'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['11'] == 1 || item['11'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['12'] == 1 || item['12'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['13'] == 1 || item['13'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['14'] == 1 || item['14'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['15'] == 1 || item['15'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['16'] == 1 || item['16'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
                  <td v-if="item['99'] == 1 || item['99'] == true"  class="green--text"> <v-chip color="success" x-small> Aktif </v-chip> </td>
                  <td v-else class="red--text">  <v-chip color="error" x-small> Tidak Aktif </v-chip> </td>
              </tr>
          </tbody>
          </template>
          <template v-slot:top>
            <v-toolbar flat style="background-color: #a1e292">
                <v-toolbar-title class='font-weight-black'>SENARAI PUSINGAN</v-toolbar-title>
                <v-spacer></v-spacer> 
                <v-btn color="primary" @click="tambahPusingan()"><span class="material-icons">add</span>Tambah Pusingan</v-btn>
            </v-toolbar>
          </template>
      </v-simple-table> -->

      <v-data-table
        :group-by="['tahun']"
        :group-desc="[true]"
        :headers="headers"
        :items="listPusingan"
        item-value="name"
        @click:row="handleclick"
      >
            <template v-slot:top>
                <v-toolbar flat style="background-color: #a1e292">
                <v-toolbar-title class='font-weight-black'>SENARAI PUSINGAN</v-toolbar-title>
                <v-spacer></v-spacer> 
                <v-btn color="primary" @click="tambahPusingan()"><span class="material-icons">add</span>Tambah Pusingan</v-btn>
            </v-toolbar>
          </template>
          <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
            <tr>
              <td :colspan="columns.length">
                <v-btn
                  :icon="isGroupOpen(item) ? '$expand' : '$next'"
                  size="small"
                  variant="text"
                  @click="toggleGroup(item)"
                ></v-btn>
                {{ item.tahun }}
              </td>
            </tr>
          </template>
      </v-data-table>
      
    </v-card>

    <!-- Modal add -->
    <v-row justify="center">
      <v-dialog
        v-model="addDialog"
        persistent
        width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Tambah Pusingan</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="addform">
            
              <v-text-field
                v-model="addPusinganForm.tahun"
                label="Tahun"
                outlined
                dense
                placeholder="2024"
              ></v-text-field>

              <v-text-field
                v-model="addPusinganForm.bulan"
                label="Bulan"
                outlined
                dense
                placeholder="09"
              ></v-text-field>

              <v-text-field
                v-model="addPusinganForm.pusingan"
                label="Pusingan"
                outlined
                dense
                placeholder="01"
              ></v-text-field>




              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="addPusinganForm.bulanmula"
                    label="Tarikh Mula"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="date = parseDate(addPusinganForm.bulanmula)"
                    v-on="on"
                    outlined
                    persistent-hint
                    hint="Tarikh Mula adalah untuk permulaan 11 bulan bagi bulan pembelian (HES)"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="addPusinganForm.bulanmula"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu> 
            

              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="addPusinganForm.bulanakhir"
                    label="Tarikh Akhir"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="date = parseDate(addPusinganForm.bulanakhir)"
                    v-on="on"
                    outlined
                    persistent-hint
                    hint="Tarikh Akhir adalah untuk perakhiran 11 bulan bagi bulan pembelian (HES)"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="addPusinganForm.bulanakhir"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>

              

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              variant="text"
              @click="addDialog = false;"
              small
            >
              batal
            </v-btn>
            <v-btn
              color="primary"
              variant="text"
              @click="addDialog = false;saveAddPusingan();"
              small
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Modal edit -->
    <v-row justify="center">
      <v-dialog
        v-model="editDialog"
        persistent
        width="700px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Kemaskini Pusingan</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="editform">
            
              <v-text-field
                v-model="editPusinganForm.tahun"
                label="Tahun"
                outlined
                dense
                placeholder="2024"
              ></v-text-field>

              <v-text-field
                v-model="editPusinganForm.bulan"
                label="Bulan"
                outlined
                dense
                placeholder="09"
              ></v-text-field>

              <v-text-field
                v-model="editPusinganForm.pusingan"
                label="Pusingan"
                outlined
                dense
                placeholder="01"
              ></v-text-field>

              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editPusinganForm.bulanmula"
                    label="Tarikh Mula"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="date = parseDate(editPusinganForm.bulanmula)"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editPusinganForm.bulanmula"
                  no-title
                  @input="menu3 = false"
                ></v-date-picker>
              </v-menu>

              <v-menu
                ref="menu4"
                v-model="menu4"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editPusinganForm.bulanakhir"
                    label="Tarikh Akhir"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="date = parseDate(editPusinganForm.bulanakhir)"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editPusinganForm.bulanakhir"
                  no-title
                  @input="menu4 = false"
                ></v-date-picker>
              </v-menu>


                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.JOHOR"
                      color="success"
                      label="JOHOR"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.KEDAH"
                      color="success"
                      label="KEDAH"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.KELANTAN"
                      color="success"
                      label="KELANTAN"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.MELAKA"
                      color="success"
                      label="MELAKA"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.N_SEMBILAN"
                      color="success"
                      label="N.SEMBILAN"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.PAHANG"
                      color="success"
                      label="PAHANG"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.P_PINANG"
                      color="success"
                      label="P.PINANG"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.PERAK"
                      color="success"
                      label="PERAK"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.PERLIS"
                      color="success"
                      label="PERLIS"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.SELANGOR"
                      color="success"
                      label="SELANGOR"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.TERENGGANU"
                      color="success"
                      label="TERENGGANU"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.SABAH"
                      color="success"
                      label="SABAH"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.SARAWAK"
                      color="success"
                      label="SARAWAK"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.KL"
                      color="success"
                      label="W.P KUALA LUMPUR"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.PUTRAJAYA"
                      color="success"
                      label="W.P PUTRAJAYA"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.LABUAN"
                      color="success"
                      label="LABUAN"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="3"
                  >
                    <v-checkbox
                      v-model="editPusinganForm.HQ"
                      color="success"
                      label="HQ"
                      hide-details
                    ></v-checkbox>
                  </v-col>

                </v-row>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              variant="text"
              @click="editDialog = false;"
              small
            >
              batal
            </v-btn>
            <v-btn
              color="primary"
              variant="text"
              @click="kemaskiniPusingan();"
              small
            >
              Kemaskini
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


</div>
</template>
<script>

import i18n from "@/i18n";
import axios from '../../plugins/axios'

import getPusingan from "@/services/pusingan";
const paparpusingan = new getPusingan();

export default {
  name: "Pusingan",
  setup() {},
  data: () => ({

    addDialog:false,
    editDialog:false,

    snackbar: "",
    errorDialog: false,
    successDialog: false,
    errMessage: '',
    successMessage: '',

    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,

    headers: [
        {text: 'ID',value: 'pusinganid'},
        { text: 'Bulan', value: 'bulan' },
        { text: 'Pusingan', value: 'pusingan' },
        
      ],
    

    rules: {
      required(text) {
        return (v) =>
          (v && v.length > 0) ||
          `${i18n.t(text)} ${i18n.t("adalahdiperlukan")}`;
      },
    },


    listPusingan:[],
    addPusinganForm : {
      id_pusingan:'',
      tahun:'',
      bulan:'',
      pusingan:'',
      bulanmula:'',
      bulanakhir:''
    },
    editPusinganForm : {
      id:'',
      id_pusingan:'',
      tahun:'',
      bulan:'',
      pusingan:'',
      bulanmula:'',
      bulanakhir:'',
      JOHOR:'',
      KEDAH:'',
      KELANTAN:'',
      MELAKA:'',
      N_SEMBILAN:'',
      PAHANG:'',
      P_PINANG:'',
      PERAK:'',
      PERLIS:'',
      SELANGOR:'',
      TERENGGANU:'',
      SABAH:'',
      SARAWAK:'',
      KL:'',
      PUTRAJAYA:'',
      LABUAN:'',
      HQ:''
    },
    currentrowindex:'',
  }),
  async beforeMount(){
 
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(){
      try {

        // var res = await paparpusingan.getSemuaPusingan();
        // console.log(res);
        const dataPusingan = await paparpusingan.getAllPusingan();
        this.listPusingan = dataPusingan.data.data;
        //console.log(this.listPusingan)
        


      } catch (err) {
        alert(err);
      }
    },
    tambahPusingan(){
      this.addDialog = true;
    },
    handleclick(rowData){
      console.log(rowData);
      // Options for formatting
      const options = {
          timeZone: 'Asia/Kuala_Lumpur',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      };
      //this.currentrowindex = index;
      this.currentrowindex = this.listPusingan.indexOf(rowData);
      this.editPusinganForm = {
        id: rowData.id,
        id_pusingan: rowData.pusinganid,
        tahun: rowData.tahun,
        bulan: rowData.bulan,
        pusingan: rowData.pusingan,
        bulanmula: rowData.bulanMula.split('T')[0],
        bulanakhir: rowData.bulanAkhir.split('T')[0],
        JOHOR: (rowData['01'] === 1),
        KEDAH: (rowData['02']=== 1),
        KELANTAN: (rowData['03']=== 1),
        MELAKA: (rowData['04']=== 1),
        N_SEMBILAN: (rowData['05']=== 1),
        PAHANG: (rowData['06']=== 1),
        P_PINANG: (rowData['07']=== 1),
        PERAK: (rowData['08']=== 1),
        PERLIS: (rowData['09']=== 1),
        SELANGOR: (rowData['10']=== 1),
        TERENGGANU: (rowData['11']=== 1),
        SABAH: (rowData['12']=== 1),
        SARAWAK: (rowData['13']=== 1),
        KL: (rowData['14']=== 1),
        PUTRAJAYA: (rowData['15']=== 1),
        LABUAN: (rowData['16']=== 1),
        HQ: (rowData['99']=== 1)
      }

      this.editDialog = true;
    },

    async saveAddPusingan(){
      var isValid = await this.$refs.addform.validate();
      if (!isValid){
        return
      }

        try {
              await axios.post(`${process.env.VUE_APP_API_URL}/pusingan/addPusingan`,
              {data : this.addPusinganForm})
              .then((response) => {
              
              if (response.data.status) {
                  this.getData();
              }else{
                  alert("failed")
              }

          })
          
        } catch (error) {
            alert("error")
        }
    },

    async kemaskiniPusingan(){

      var isValid = await this.$refs.editform.validate();
      if (!isValid){
        return
      }

        try {
              await axios.post(`${process.env.VUE_APP_API_URL}/pusingan/editPusingan`,
              {data : this.editPusinganForm})
              .then((response) => {
              
              if (response.data.status) {
                  this.editDialog = false;
                  this.getData();
              }else{
                alert("failed")
                  this.editDialog = false;
              }

          })
          
        } catch (error) {

            alert("error")
            this.editDialog = false;
        }
    }

  },
  watch: {},
};
</script>